import React from 'react'
import { useTranslation } from "react-i18next";

const Tr = (props) => {
    const { t } = useTranslation();

    const oripa = props.oripa;
    const openModal = props.openModal;
    const openImageModal = props.openImageModal;
    const cardNumber = props.cardNumber;
    const confirmPackage = props.confirmPackage;
    const cardList = props.cardList;
    const setCardList = props.setCardList;
    const setCurrentCard = props.setCurrentCard;

    const editCard = (e) => {
        e.preventDefault();

        let oripa = cardList.find(card => card.id === parseInt(e.target.value));
        setCurrentCard({
            ...oripa,
            update: true,
        });
        
        openModal();
    }

    const deleteCard = (e) => {
        e.preventDefault();
        
        let oripa = cardList.find(card => card.id === parseInt(e.target.value));
        
        if (window.confirm(`${oripa.name}`+ t('tr.confirm'))) {
            let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
            if (xsrfToken) {
                xsrfToken = xsrfToken.split('=')[1]
            }
            let token = document.cookie.split('; ').find(row => row.startsWith('token'));
            if (token) {
                token = token.split('=')[1]
            }

            fetch(`${process.env.REACT_APP_API_URL}/api/package-card/delete/${oripa.id}`, {
                method: 'POST',
                headers: {
                'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                'Bearer': decodeURIComponent(token)
                },
                credentials: 'include',
            })
            .then(response => {
                if (!response.ok) {
                    // data.messageにエラーメッセージが入っている
                    return response.json().then(data => {
                        throw new Error(data.message);
                    });
                }
                return response.json();
            })
            .then(data => {
                if(!data.errors) {
                    let newCardList = cardList.filter(card => card.id !== oripa.id);
                    setCardList(newCardList);
                }
            })
            .catch((error) => {
                alert(error.message);
                console.error('Error:', error);
            });
        }
    }


    return (
        <>
            <tr>
                <td><img src={oripa.url} alt="" onClick={openImageModal}/></td>
                <td>{oripa.name}</td>
                {oripa.rank == 9 ?
                    <>
                    <td>{t('tr.num')}</td>
                    <td>{t('tr.last')}{oripa.number}</td>
                    <td>{oripa.rewardPoint}</td>
                    <td>{oripa.isPsaEnabled == "1" ? <>PSA {oripa.psa}</> : <>-</>}</td>
                    <td><div>-</div></td>
                    </>
                :
                <>
                    <td>{oripa.rank}{t('tr.rank')}</td>
                    <td>{oripa.stock}/{oripa.number}</td>
                    <td>{oripa.rewardPoint.toLocaleString()}</td>
                    <td>{oripa.isPsaEnabled == "1" ? <>PSA {oripa.psa}</> : <>-</>}</td>
                    <td><div>{oripa.number / cardNumber * 100}%</div></td>
                </>
                }
                <td>
                    {!confirmPackage && <button value={oripa.id} onClick={editCard}>{t('tr.edit')}</button>}<br/>
                    {!confirmPackage && <button value={oripa.id} onClick={deleteCard}>{t('tr.delete')}</button>}
                </td>
            </tr>
        </>
    )
}

export default Tr